import { queryClient } from '@capsicum/common';
import { type InfiniteQueryPostActivityType } from '@capsicum/features/feeds/shared';
import { type FetchMeActivities, type PostActivityType } from '@capsicum/socios-core';
import { type InfiniteData } from '@tanstack/react-query';
import { type QueryKey } from '@tanstack/react-query/build/modern/index';

export type FlashListType = PostActivityType & { component: string; id: string };

export const clearFeedPages = (key: QueryKey) => {
	queryClient.setQueryData<InfiniteQueryPostActivityType>(key, oldData => {
		return oldData
			? {
					pageParams: oldData.pageParams.filter((_, index) => index === 0),
					pages: oldData.pages.filter((_, index) => index === 0)
				}
			: undefined;
	});
};

export const prepareFeedData = (data: InfiniteData<FetchMeActivities<PostActivityType>, unknown> | undefined) => {
	const feedData = data?.pages?.flatMap(page => page?.data) || [];
	const metadata = data?.pages?.flatMap(page => page?.metadata) || {};

	return { feedData, metadata };
};

export const keyExtractorFunction = (item: FlashListType, index: number): string => {
	const key = item?.activityId ?? item?.id ?? index.toString();

	return key + index; //For avoiding duplicated activities.
};
